import { AccessibleMedia } from "../AccessibleMedia";
import { Button } from "@components/shared/core/Button";
import { Link } from "@components/shared/core/Link";
import { useTranslation } from "@services/i18n";
import { OBELIX_BLOG_KEYS } from "@utils/obelixKeys";

export const BlogCard = ({
  post,
  variant,
}:{
  post: any;
  variant?: string;
}) => {
  const { t } = useTranslation();
  const label = t(OBELIX_BLOG_KEYS.readPost.obelixKey, OBELIX_BLOG_KEYS.readPost.label);

  if (!post) {
    return <></>;
  }

  if (variant === 'full') {
    return (
      <div className="blog-card w-full text-center">
        <Link href={`/blog/${post.slug}`}>
          <AccessibleMedia item={post.heroImage} noCaption />
        </Link>
        <h2 className="text-heading-3 capitalize max-w-[1280px] text-balance my-[30px] dsk:my-[64px] mx-auto">{post.postTitle}</h2>
        {post.postSummary &&
          <div className="postSummary max-w-[874px] mx-auto my-[30px]">
            <p className="font-medium">{post.postSummary}</p>
          </div>
        }
        {post.slug &&
          <Button variant="light-on-dark" className="my-[30px]" asChild>
            <Link href={`/blog/${post.slug}`}>{label}</Link>
          </Button>
        }
      </div>
    );
  }

  return (
    <div className="blog-card max-w-[386px] text-center flex flex-col items-center justify-between">
      <div>
        <AccessibleMedia item={post.heroImage} noCaption />
        <h3 className="text-heading-4 mt-[36px]">{post.postTitle}</h3>
        {post.postTldr &&
          <p className="text-body-small pt-[20px]">{post.postTldr}</p>
        }
      </div>
      {post.slug &&
        <Button variant="light-on-dark" className="mt-[30px]" asChild>
          <Link href={`/blog/${post.slug}`}>{label}</Link>
        </Button>
      }
    </div>
  );
};
